import { AbstractControl, Validators } from '@angular/forms'

/**
 * Extension of Validators.required that treats whitespace as an empty value.
 */
export const requiredValidator = Validators.compose([
  Validators.required,
  (control: AbstractControl) =>
    typeof control.value === 'string' && control.value.trim().length === 0 ? { required: true } : null,
])
